<template>
  <div class="app-container">
    <CrudTable entity="Customer" :columns="columns" :use-pagination="true" />
  </div>
</template>

<script>
import CrudTable from '@/components/crud/CrudTable';
export default {
  components: {
    CrudTable
  },
  data() {
    return {
      columns: [
        { field: 'customerName', label: 'customer.customerName' },
        { field: 'customerLocation', label: 'customer.customerLocation' },
        { field: 'licenseKey', label: 'customer.licenseKey' },
        { field: 'version', label: 'customer.version' },
        { field: 'numberOfLicenses', label: 'customer.numberOfLicenses' },
        { field: 'userCount', label: 'customer.userCount' },
        { field: 'refreshXDays', label: 'customer.refreshXDays' },
        { field: 'dateIssued', label: 'customer.dateIssued', type: 'dateTime', format: 'dd-MM-yyyy' },
        { field: 'validUntilDate', label: 'customer.validUntilDate', type: 'dateTime', format: 'dd-MM-yyyy' },
        { field: 'locked', label: 'customer.locked' },
        { field: 'isMobileAllowed', label: 'customer.isMobileAllowed' },
        { field: 'renewalPossible', label: 'customer.renewalPossible' }
      ]
    };
  }
};
</script>

<style scoped></style>
